// LogoutPage.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore3';

const LogoutPage: React.FC = () => {
  const { logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error("Ошибка при выходе:", error);
      } finally {
        // { replace: true } заменяет /logout в истории браузера, 
        // чтобы пользователь не вернулся туда при нажатии кнопки "Назад"
        navigate('/', { replace: true }); 
      }
    };

    performLogout();
  }, [logout, navigate]);

  return <div>Exiting...</div>;
};

export default LogoutPage;